module.exports = __webpack_public_path__ + "static/media/MARANOA REGIONAL.5e240d37.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/council_areas/MARANOA REGIONAL.svg
// module id = 561
// module chunks = 0